<script setup>
defineProps({
    theme: {
        type: String,
        default: 'default', // default, highlight, gradient-highlight, gradient-vibrand-highlight
        validator(value) {
            return ['default', 'highlight', 'gradient-highlight', 'gradient-vibrand-highlight'].includes(value)
        },
    },
})
</script>

<template>
    <div
        class="card"
        :class="theme"
    >
        <div
            v-if="$slots['header']"
            class="card-header"
        >
            <slot name="header"/>
        </div>
        <slot />
        <div
            v-if="$slots['footer']"
            class="card-footer"
        >
            <slot name="footer"/>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.card {
    padding: $s-s;
    border-radius: $radius-8;

    // THEMES
    &.default {
        background-color: $c-surface-overlay;
    }

    &.highlight {
        background-color: $c-highlight;
    }

    &.gradient-highlight {
        background: $c-accent-subtle;
    }

    &.gradient-vibrand-highlight {
        background: $c-accent-subtle;
    }
}

.card-content {
    position: relative;
    width: 100%;
    height: 100%;
}

.card-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
}

@include tablet {
    .card {
        padding: $s-l;
    }
}
</style>
